import React, { memo } from "react";
import Checkbox from "semantic-ui-react/dist/es/modules/Checkbox";

import "./CustomCheckBox.scss";

const CustomCheckBox = memo(({ label, checked, className, onClick, disabled, type, ...props }) => {
    const handleClick = () => {
        if (disabled) return;
        onClick(!checked);
    };

    return (
        <div
            className={`custom-checkbox ${type === "non-checkbox" && checked ? type : ""} ${className ? className : ""} ${disabled ? "disabled" : ""}`}
            onClick={handleClick}>
            <span className="label">{label}</span>
            {type !== "non-checkbox" && <Checkbox checked={checked} label="" disabled={disabled} />}
        </div>
    );
});

export default CustomCheckBox;
